'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoLogOut = function IoLogOut(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.2 25.3l4-4h-17.7v-2.5h17.7l-4-4.1 1.7-1.8 7.1 7.1-7.1 7.1z m1.8 5.3c0.3-0.2 0.5-0.4 0.7-0.6h3.2c-3.1 4.5-8.5 7.5-14.4 7.5-9.7 0-17.5-7.8-17.5-17.5s7.8-17.5 17.5-17.5c5.9 0 11.3 3 14.4 7.5h-3.2c-0.2-0.2-0.4-0.4-0.7-0.6-2.8-2.8-6.5-4.4-10.5-4.4s-7.8 1.6-10.6 4.4-4.4 6.6-4.4 10.6 1.6 7.8 4.4 10.6 6.6 4.4 10.6 4.4 7.7-1.6 10.5-4.4z' })
        )
    );
};

exports.default = IoLogOut;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/log-out.js
// module id = 2578
// module chunks = 0